import { Cell, ICell } from '.'

export interface IIconColumnSettings {
  Settings: null
}

export interface IIconCell extends ICell {
  settings: null
}

export class IconCell implements IIconCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value === null || this.value === undefined) {
      return ''
    }

    // Convert value to string representation
    return this.value.toString() ?? ''
  }

  toCell<T extends Cell>(value: T) {
    if (!value || typeof value !== 'string') {
      this.value = ''
      return this
    }

    return this
  }
}
